module.exports = __webpack_public_path__ + "static/media/tomWarsop.c2818905.png";